import { render, staticRenderFns } from "./ActiveFilters.vue?vue&type=template&id=06b4e38f&scoped=true&"
import script from "./ActiveFilters.vue?vue&type=script&lang=js&"
export * from "./ActiveFilters.vue?vue&type=script&lang=js&"
import style0 from "./ActiveFilters.vue?vue&type=style&index=0&id=06b4e38f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b4e38f",
  null
  
)

export default component.exports